  import { COLUMNS_DIMENSION_PROPERTIES } from "@mui/x-data-grid/internals";
import TrackingHttp from "../../trackingHttp";
  
  class TrackingServices {
  
  
  static async getTrackingData({ ownerId, vehicleRouteId, busId }) {
    try {
      console.error("busId",busId)
      const params = [];
      if (ownerId) params.push(`owner_id=${ownerId}`);
      if (vehicleRouteId) params.push(`vehicleRoute_id=${vehicleRouteId}`);
      if (busId) params.push(`vehicle_id=${busId}`);
      const query = params.length ? `?${params.join('&')}` : '';
      const response = await TrackingHttp.get(`/tracking/today${query}`);
      return response;
    } catch (error) {
      console.error('Error fetching tracking data:', error);
      return null;
    }
  }
static async getTripSummary({ownerId,tripType}){
  // console.log("tripType")
  return TrackingHttp.get(`/tracking/trackingStartedlist/${ownerId}?tripType=${tripType}`); 
}
static async getTrackingHistory({ownerId,busId,tripType,date}){
  console.log("date",date)
  return TrackingHttp.get(`/tracking/history/${ownerId}?busId=${busId}&tripType=${tripType}&date=${date}`)
}
}
export default TrackingServices;